<template>
  <div class="content-box">
    <div class="w-save">
      <el-image src="/static/imgs/banner@2x.png" fit="cover" class="saveimg" />
      <div class="forms w1200">
        <el-card class="box-card">
          <div class="cens-aaa">
            <div class="fbxj">发布询价</div>
            <div class="needs">Needs</div>
          </div>
          <div><el-input v-model="form.telephone" maxlength="11" placeholder="联系方式" style="margin-bottom: 0;" /></div>
          <div class="dis">
            <div class="temor">
              <el-dropdown trigger="click" @command="handleCommandTwo">
                <span class="el-dropdown-link2">
                  <span :class="iscshow?'blacks':''">{{fenlei}}</span> <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="item.name" v-for="(item,index) in restaurants"
                    :key="index">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="temor dis" style="margin: 0;">
              <div class="w85">
                <el-input v-model="form.inquiryAmount" placeholder="需求数量" class="mm0" min="0" maxlength="7"
                  type="number" />
              </div>
              <div class="w15">
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{form.inquiryUnit}} <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="item.name" v-for="(item,index) in unitArr"
                      :key="index">{{item.name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>


              </div>
            </div>
          </div>
          <div class="mjk">
            <!-- <el-input v-model="form.address"  /> -->
            <el-cascader v-model="form.address" :options="options" ref='postSelectRef' placeholder="收货地址"
              :props="{ expandTrigger: 'click' ,value:'id', label: 'label', children: 'children'}"
              @change="handleChange">
            </el-cascader>
          </div>
          <div>
            <el-input type="textarea" placeholder="需求描述" v-model="form.inquiryDesc" maxlength="300" show-word-limit
              :autosize="{ minRows: 6, maxRows: 6}" />
          </div>
          <div class="tibtn" @click="addUp">提交询价</div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

    data() {
      return {
        form: {
          inquiryUnit: '立方',
        },
        restaurants: [],
        unitArr: this.datms.unitArr,

        options: [],
        nameBox: [],
        fenlei: '分类',
        iscshow: false
      }
    },
    mounted() {
      this.getCity()
      for (let i in this.$store.state.caizhi) {
        this.$store.state.caizhi[i].name = this.$store.state.caizhi[i].itemValue
        this.$store.state.caizhi[i].val = this.$store.state.caizhi[i].itemCode
      }
      this.restaurants = this.$store.state.caizhi
    },
    methods: {
      getCity() {
        this.$request('get', this.$wxapi + 'operation/miniall', {}, (res) => {
          this.options = this.edits(res.data.data.data)
        })
      },
      edits(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children.length < 1) {
            data[i].children = undefined || ''
          } else {
            this.edits(data[i].children)
          }
        }
        return data;
      },
      querySearch(queryString, cb) {
        let restaurants = this.restaurants;
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },

      querySearchDan(queryString, cb) {
        let restaurants = this.unitArr;
        let results = queryString ? restaurants.filter(this.createFilterDan(queryString)) : restaurants;
        cb(results);
      },
      createFilterDan(queryString) {
        return (restaurant) => {
          return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleCommand(e) {
        this.form.inquiryUnit = e
      },


      handleCommandTwo(e) {
        this.form.categoryId = this.restaurants.filter(item => item.name == e)[0].val
        this.form.categoryName = e
        this.fenlei = e
        this.iscshow = true
      },
      handleChange(val) {
        this.nameBox = this.$refs["postSelectRef"].getCheckedNodes()[0].pathLabels
      },
      addUp() {

        if (!this.form.categoryName) {
          this.$notify.error({
            title: '错误',
            message: '请选择分类',
            position: 'top-left'
          });
          return false;
        }

        if (!this.form.inquiryDesc) {

          this.$notify.error({
            title: '错误',
            message: '请输入需求描述',
            position: 'top-left'
          });
          return false;
        }

        if (!this.phone(this.form.telephone)) {
          this.$notify.error({
            title: '错误',
            message: '请输入正确的联系方式',
            position: 'top-left'
          });
          return false;
        }
        if (this.nameBox.length) {
          this.form.provinceName = this.nameBox[0]
          this.form.provinceId = this.form.address[0]
          this.form.cityName = this.nameBox[1]
          this.form.cityId = this.form.address[1]
          this.form.areaName = this.nameBox[2]
          this.form.areaId = this.form.address[2]
        }

        delete this.form.address

        if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          this.form.channelType = 4
        } else {
          this.form.channelType = 5
        }
        this.$request('post', this.$wxapi + 'inquiry/save', this.form, (res) => {

          if (res.data.code == 200) {
            this.form = {
              inquiryUnit: '立方'
            }
            this.fenlei = '分类'
            this.iscshow = false
            this.$forceUpdate()

            this.$alert('感谢留言，我们会尽快与您联系', '提交成功', {
              confirmButtonText: '确定',
            });

          } else {
            this.$notify.error({
              title: '错误',
              message: '提交失败',
              position: 'top-left'
            });
          }
        }, (err) => {
          this.$notify.error({
            title: '错误',
            message: '提交失败',
            position: 'top-left'
          });
        })

      },
      phone(str) {
        let reg = /^1[3456789]\d{9}$/;
        return reg.test(str)
      }
    },
    metaInfo() {
      return {
        title: '聚木网-发布询价'
      }
    }
  }
</script>

<style scoped>
  .forms {
    margin: 50px auto;
  }

  .fbxj {
    margin: 30px 0 20px 0;
    font-size: 32px;
    font-weight: bold;
    color: #1D2129;
  }

  .needs {
    font-weight: bold;
    color: #1D2129;
    font-size: 20px;
    margin-bottom: 25px;
  }

  .temor {
    width: 560px;
  }

  .dis {
    margin-top: 24px;
    flex-wrap: wrap;
  }

  .el-input {
    margin-bottom: 22px;
  }

  .el-autocomplete {
    width: 100%;
  }

  .el-cascader {
    width: 100%;
  }

  .mjk {
    margin: 22px 0;
  }

  .tibtn {
    width: 154px;
    height: 58px;
    text-align: center;
    line-height: 58px;
    color: #fff;
    font-weight: bold;
    margin: 34px auto;
    font-size: 16px;
    background: #6b78e5;
    border-radius: 5px;
    cursor: pointer;
  }

  .el-dropdown-link2 {
    display: block;
    width: 570px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 9px 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #ccc;
  }

  .mm0 {
    margin-bottom: 0;
  }

  .w85 {
    width: 81%;
  }

  .w15 {
    width: 19%;
  }

  .p-m46 {
    margin-top: 4.6rem;
  }

  .blacks {
    color: #000;
  }

  .el-dropdown-link {
    text-align: center;
    display: block;
    width: 85px;
    border: 1px solid #ccc;
    border-radius: 0 5px 5px 0;
    padding: 9px;
    border-left: none;
  }


  .cens-aaa {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/save.vue